function readCookie(key) {
    const name = key + '=';
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }

        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }

    return null;
}

function removeCookie(name) {
    document.cookie = name + '=; domain=.unearthlabs.com; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT';
}

export default {readCookie, removeCookie};
